module.exports = __webpack_public_path__ + "021c3a811a96afe7f4eed93938ebbaa3.svg";